import { Box } from '@abyss/web/ui/Box';
import { Brandmark } from '@abyss/web/ui/Brandmark';
import React from 'react';

interface GuestLogoProps {
  headerData?: {
    lob: string;
    coverage: string;
    signinUrl: string;
    brandmarkAffiliate: string;
    brandmarkVariant: string;
    languages: string;
  } | null;
}

export const GuestLogo: React.FC<GuestLogoProps> = ({ headerData }) => {
  const hasCustomBrandmark =
    headerData?.brandmarkAffiliate && headerData?.brandmarkVariant;

  return (
    <Box
      css={{
        'abyss-box-root': {
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          maxWidth: '242px',
          height: '48px',
          backgroundColor: '$white',
        },
      }}
    >
      {hasCustomBrandmark ? (
        <Brandmark
          affiliate={headerData.brandmarkAffiliate}
          brand="uhc"
          color="blue"
          css={{
            'abyss-brandmark': {
              height: '42px',
              width: 'auto',
              display: 'block',
            },
          }}
          data-testid="guest-logo-brandmark"
          size="100%"
          variant={headerData.brandmarkVariant}
        />
      ) : (
        <Brandmark
          affiliate="uhc"
          brand="uhc"
          color="blue"
          css={{
            'abyss-brandmark': {
              height: '42px',
              width: 'auto',
              display: 'block',
            },
          }}
          size="100%"
          variant="lockup"
        />
      )}
    </Box>
  );
};
